import React from 'react';
import { connect } from 'react-redux';
import { Typography } from '@americanexpress/aqx-components';
import OfferBoxShared from 'src/universal/components/OfferBoxForLandingPages';
import { getCombinedG163Data } from './redux';
import styles from './__styles__/index.scss?modules';

const OfferBox = ({ staticG163Data, currCard }) => {
  return (
    <div id="gcsPdpSeamlessCampaignOfferBox" className={styles.seamlessOfferBox}>
      <Typography Component="h2" className={styles.offerBoxSecHead}>
        {staticG163Data?.offerBox?.sectionHeader}
      </Typography>
      <OfferBoxShared shortName={currCard.shortName} isForHero={true} />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    ...getCombinedG163Data(state)
  };
};

export default connect(mapStateToProps)(React.memo(OfferBox));
